import type {ValueOf} from '@myparcel-frontend/types';
import type {Dayjs} from '@myparcel-frontend/utils';
import {dayjs} from '@myparcel-frontend/utils';
import {DateFilterOption} from './DatesRadioGroupAndDatePickerField.types';
import {formatDateToUTC} from '@/utils/dateTime';

const getStartAndEndDates = (orderedAt: ValueOf<typeof DateFilterOption>, startDate?: string, endDate?: string) => {
  const today = dayjs().startOf('day');
  const tomorrow = dayjs().add(1, 'day').startOf('day');
  const oneDayAgo = dayjs().subtract(1, 'day').startOf('day');
  const twoDaysAgo = dayjs().subtract(2, 'day').startOf('day');
  const threeDaysAgo = dayjs().subtract(3, 'day').startOf('day');

  switch (orderedAt) {
    case DateFilterOption.Today:
      return {start: today, end: tomorrow};
    case DateFilterOption.OneDayAgo:
      return {start: oneDayAgo, end: today};
    case DateFilterOption.TwoDaysAgo:
      return {start: twoDaysAgo, end: oneDayAgo};
    case DateFilterOption.ThreeDaysAgo:
      return {start: threeDaysAgo, end: twoDaysAgo};
    case DateFilterOption.Period:
      return {
        start: startDate ? dayjs(startDate) : undefined,
        end: endDate ? dayjs(endDate) : undefined,
      };
    default:
      return {start: undefined, end: undefined};
  }
};

const formatStartAndEndDates = (start: Dayjs | undefined, end: Dayjs | undefined, format: string) => {
  if (start && !start.isValid()) {
    start = undefined;
  }

  if (end && !end.isValid()) {
    end = undefined;
  }

  return {
    start: start ? formatDateToUTC(start, format) : undefined,
    end: end ? formatDateToUTC(end, format) : undefined,
  };
};

export const getDateFilter = (orderedAt: ValueOf<typeof DateFilterOption>, startDate?: string, endDate?: string) => {
  const format = 'YYYY-MM-DDTHH:mm:ss[Z]';

  const {start, end} = getStartAndEndDates(orderedAt, startDate, endDate);
  const {start: formattedStart, end: formattedEnd} = formatStartAndEndDates(start, end, format);

  const finalStart = formattedStart ? `gte ${formattedStart}` : undefined;
  const finalEnd = formattedEnd ? `lt ${formattedEnd}` : undefined;

  return [finalStart, finalEnd];
};
